import React from 'react';
import {classes, style} from './doppe-action-type-widget-show-more-button.st.css';
import {CommonClasses} from '@wix/devzai-common-client';
import {Button, flexRowAlignToCenter, Icon} from '@wix/devzai-utils-react';
import IconChevronUp from '../doppe-action-button-templates/doppe-standard-action-button-template/icons/ChevronUp.svg';
import IconChevronDown
    from '../doppe-action-button-templates/doppe-standard-action-button-template/icons/ChevronDown.svg';
import {useDoppeViewerLocales} from '../../client/doppe-viewer-locales/doppe-viewer-locales';

export const DoppeActionTypeWidgetShowMoreButton = React.memo(function DoppeActionTypeWidgetInnerDescription(props: DoppeActionTypeWidgetInnerDescription.Props) {
    const {
        className,
        isOpen = false,
        ...htmlAttributes
    } = props;

    const viewerLocales = useDoppeViewerLocales();

    return (
        <Button
            {...htmlAttributes}
            className={style(classes.root, {}, flexRowAlignToCenter(), CommonClasses.button)}
        >
            <div>{isOpen ? viewerLocales.viewLessButton : viewerLocales.viewMoreButton}</div>
            <Icon
                className={style(classes.chevronIcon, {})}
                icon={isOpen ? IconChevronUp : IconChevronDown}
            />
        </Button>
    );
});

export namespace DoppeActionTypeWidgetInnerDescription {

    export interface Props extends React.HTMLAttributes<any> {
        isOpen: boolean;
    }
}

